import { render, staticRenderFns } from "./Plaquenil.vue?vue&type=template&id=1bb04162&scoped=true&"
import script from "./Plaquenil.vue?vue&type=script&lang=js&"
export * from "./Plaquenil.vue?vue&type=script&lang=js&"
import style0 from "./Plaquenil.vue?vue&type=style&index=0&id=1bb04162&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb04162",
  null
  
)

export default component.exports